export default __webpack_public_path__ + "static/media/human.7430a07a.svg";